// C2 · Hero (sections/c2-hero.liquid): slides, arrows / dots / progress tabs, autoplay (pauses on hover,
// focus and when the tab is hidden; off with reduced motion), and the text animation of each slide.
(() => {
  const init = (root) => {
    if (root.dataset.c2hReady) return;
    root.dataset.c2hReady = '1';
    const track = root.querySelector('[data-c2h-track]');
    const slides = [...root.querySelectorAll('[data-c2h-slide]')];
    const goButtons = [...root.querySelectorAll('[data-c2h-go]')];
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Number(root.dataset.autoplay || 0);
    let index = 0, timer = null, paused = false, start = 0;

    const show = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    };
    const mark = (i) => {
      index = i;
      goButtons.forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.c2hGo) === i)));
      slides.forEach((s, n) => s.querySelector('.c2h-anim')?.classList.toggle('is-in', n === i));
      start = performance.now();
    };

    // which slide is in view
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > 0.6) mark(slides.indexOf(e.target)); });
    }, { root: track, threshold: [0.6] });
    slides.forEach((s) => io.observe(s));
    // the first slide's text animates as soon as the hero is on screen
    new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) { mark(index); obs.disconnect(); }
    }).observe(root);

    root.querySelectorAll('[data-c2h-step]').forEach((b) => b.addEventListener('click', () => { show(index + Number(b.dataset.c2hStep)); start = performance.now(); }));
    goButtons.forEach((b) => b.addEventListener('click', () => { show(Number(b.dataset.c2hGo)); start = performance.now(); }));

    if (delay && slides.length > 1 && !reduce) {
      const fills = [...root.querySelectorAll('[data-c2h-fill]')];
      let last = performance.now();
      const tick = (now) => {
        if (paused || document.hidden) {
          start += now - last; // frozen: the time spent paused doesn't count
        } else {
          const p = Math.min(1, (now - start) / delay);
          fills.forEach((f, n) => { f.style.width = n === index ? `${p * 100}%` : (n < index ? '100%' : '0'); });
          if (p >= 1) { show(index + 1); start = now; }
        }
        last = now;
        timer = requestAnimationFrame(tick);
      };
      ['mouseenter', 'focusin'].forEach((ev) => root.addEventListener(ev, () => { paused = true; }));
      ['mouseleave', 'focusout'].forEach((ev) => root.addEventListener(ev, () => { paused = false; }));
      start = performance.now();
      timer = requestAnimationFrame(tick);
    }
  };
  const run = () => document.querySelectorAll('[data-c2h]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run); // theme editor
})();
